import React from 'react'
import { Typography, Box } from '@material-ui/core'
import { ArcherElement } from 'react-archer'

import { ConnectionPoints } from '../'

import useStyles from '../../styles'

const AnnotationElement = ({ element }) => {
  const classes = useStyles()

  return (
    <ArcherElement
      key={element.id}
      id={element.id}
      relations={element.relations}
    >
      <Box
        className={classes.boxText}
        style={{
          borderColor: element.color || 'black',
        }}
      >
        <Typography
          variant="body1"
          style={{
            color: element.textColor || 'black',
            fontWeight: 'bold',
          }}
        >
          {element.name}
        </Typography>

        <ConnectionPoints connectionTypes={element.connectionTypes} />
      </Box>
    </ArcherElement>
  )
}

export default AnnotationElement
